<script>
  import { getNextInputId } from "../../helper/UIHelper";
  import Checklist from "../display/Checklist.svelte";

  export let model;
  export let label;
  export let placeholder;
  export let hint;

  export let uid;
  export let required = false;
  let className = "";
  let typeName = "text";

  let hasFocus = false;
  export { className as class };
  export { typeName as type };

  if (uid == null) uid = getNextInputId();

  const onFocus = function() {
    hasFocus = true;
  };

  const onBlur = function() {
    hasFocus = false;
  };
</script>

<style>
  .box:after {
    content: " ";
    position: absolute;
    right: -12px;
    top: 50%;
    transform: translate(0, -50%);
    border-top: 12px solid transparent;
    border-right: none;
    border-left: 12px solid #e5e7eb;
    border-bottom: 12px solid transparent;
  }
</style>

<div class={className}>
  {#if label != null}
    <label for={uid} class="block text-m font-medium leading-5 text-main mb-1">
      {label}
    </label>
  {/if}
  <div class="relative">
    <div class="rounded-md shadow-sm">
      <!-- Why if not setting type dynamically (type={typeName})? Svelte does not allow to make a dynamic type when using two-way binding (bind: value={model})-->
      {#if typeName == 'email'}
        <input
          bind:value={model}
          id={uid}
          {placeholder}
          type="email"
          on:blur={onBlur}
          on:keyup
          on:focus={onFocus}
          {required}
          class="form-input block w-full transition duration-150 ease-in-out
          sm:text-m sm:leading-5" />
      {:else}
        <input
          bind:value={model}
          id={uid}
          {placeholder}
          type="text"
          on:blur={onBlur}
          on:keyup
          on:focus={onFocus}
          {required}
          class="form-input block w-full transition duration-150 ease-in-out
          sm:text-m sm:leading-5" />
      {/if}
    </div>
    {#if hint != null && typeof hint == 'object' && hasFocus}
      <div
        class="modal bg-gray-200 box shadow rounded-lg absolute p-2 text top-1/2
        z-20 sm:text-m sm:leading-5"
        style="width:300px; left: -320px;transform:translate(0, -50%)">
        <Checklist list={hint} />
      </div>
    {/if}
  </div>
  {#if hint != null && typeof hint == 'string'}
    <div class="mt-1 text-xs text-gray-400">{hint}</div>
  {/if}
</div>
